import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import GlobalStyle from './styles/GlobalStyle';
import ReactionPage from './components/ReactionPage';
import CompletePage from './components/CompletePage';
import ExpiredPage from './components/ExpiredPage';
import RespondedPage from './components/RespondedPage';
import ErrorPage from './components/ErrorPage';
import NotFoundPage from './components/NotFoundPage';

function App() {
  return (
    <>
      <GlobalStyle />
      <Router>
        <Switch>
          <Route exact path="/r/:uid" component={ReactionPage} />
          <Route path="/r/:uid/complete" component={CompletePage} />
          <Route path="/r/:uid/expired" component={ExpiredPage} />
          <Route path="/r/:uid/responded" component={RespondedPage} />
          <Route path="/r/:uid/error" component={ErrorPage} />
          <Route component={NotFoundPage} />
        </Switch>
      </Router>
    </>
  );
}

export default App;
